/**
 * DevExtreme (esm/ui/pivot_grid/sortable/const.js)
 * Version: 22.2.4
 * Build date: Thu Jan 19 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var SortableConst = {
    targets: {
        drag: "drag"
    },
    classes: {
        areaBox: "dx-area-box",
        areaField: "dx-area-field",
        fieldsContainer: "dx-pivotgrid-fields-container",
        widget: "dx-widget"
    },
    attrs: {
        treeViewItem: "tree-view-item"
    }
};
